export default "__VITE_ASSET__DDa4SzHf__"